export const MONITORING_TIME_FILTERS = [
  { label: 'data di compilazione', value: null },
  { label: 'ultimi 6 mesi', value: '6m' },
  { label: 'ultimi 3 mesi', value: '3m' },
  { label: 'ultimo mese', value: '1m' },
  { label: 'ultima settimana', value: '1w' },
  { label: 'ultime 24 ore', value: '1d' },
]